import React from 'react';
import { AttentionMessage } from '@tq/ui-components';

import { useNotesInfoText } from './useNotesInfoText';
import { useCanAddNote } from 'hooks';
import { Consultation } from 'types';

export type NoteInfoMessageProps = {
  consultation?: Consultation;
};
export const NotesInfoMessage: React.FC<NoteInfoMessageProps> = ({ consultation }) => {
  const canAddNote = useCanAddNote(consultation);
  const notesInfo = useNotesInfoText();
  return canAddNote ? (
    <AttentionMessage variant='standard' description={notesInfo} mb={6} />
  ) : null;
};
